import React from "react";
import styled from "styled-components";
import { ViewPager, Frame, Track, View } from "react-view-pager";
import MdClose from "react-icons/lib/md/close";
import MdChevronRight from "react-icons/lib/md/chevron-right";
import MdChevronLeft from "react-icons/lib/md/chevron-left";
import componentQueries from "react-component-queries";
/* eslint import/no-unresolved: off */
/* eslint import/no-webpack-loader-syntax: off */
import Img from "./image";
import Masonry from "./masonry";

const Image = styled(Img)`
  cursor: ${({ pointer }) => (pointer ? "pointer" : "initial")};
  width: initial;
  max-height: 100%;
`;

Image.containerCSS = `
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Container = styled.div`
  img {
    // max-height: 80vh;
    // width: initial !important;
    // filter: none !important;
  }
`;

const Backdrop = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999999;
  background-color: rgba(0, 0, 0, 0.9);
  width: 100vw;
  height: 100vh;
  svg {
    fill: white;
  }
  svg:hover {
    fill: rgb(180, 180, 180);
    cursor: pointer;
  }
`;

const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const Slide = styled.div`
  width: 80vw;
  height: 90vh;
`;

const CloseContainer = styled.div`
  position: fixed;
  right: 10px;
  top: 5px;
`;

const ChevronContainer = styled.div`
  position: fixed;
  left: ${({ left }) => left};
  right: ${({ right }) => right};
`;

const Lightbox = componentQueries(({ width }) => {
  console.log("lightbox width", width);

  const layoutProps = (function() {
    const dFault = {
      chevrons: {
        show: false
      }
    };
    if (width >= 1023) {
      return {
        chevrons: {
          show: true
        }
      };
    }
    return dFault;
  })();
  return {
    layoutProps
  };
})(props => {
  const {
    layoutProps,
    onClose,
    onChange,
    currentIndex,
    onNext,
    onPrev
  } = props;
  const slides = props.images.map((img, i) => {
    return (
      <View className="view" key={i}>
        <Slide name="slide">
          <Image containerCSS={Image.containerCSS} file={img} />
        </Slide>
      </View>
    );
  });
  return (
    <Backdrop name="backdrop">
      <CloseContainer>
        <MdClose size={30} onClick={onClose} />
      </CloseContainer>
      <Center>
        {layoutProps.chevrons.show && (
          <ChevronContainer left="10px">
            {onPrev && <MdChevronLeft onClick={onPrev} size={75} />}
          </ChevronContainer>
        )}
        <ViewPager>
          <Frame accessibility autoSize className="frame">
            <Track
              currentView={currentIndex}
              onViewChange={onChange}
              infinite={false}
              swipe
              viewsToShow={1}
              className="track"
            >
              {slides}
            </Track>
          </Frame>
        </ViewPager>

        {layoutProps.chevrons.show && (
          <ChevronContainer right="10px">
            {onNext && <MdChevronRight onClick={onNext} size={75} />}
          </ChevronContainer>
        )}
      </Center>
    </Backdrop>
  );
});

export default class extends React.Component {
  state = {
    lightboxIndex: null
  };

  componentWillMount() {
    window.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  setLightboxIndex = i => {
    this.setState({
      lightboxIndex: i
    });
  };

  handleKeyDown = e => {
    if (e.key === "Escape") {
      this.closeLightbox();
    }
  };

  closeLightbox = () => {
    this.setState({
      lightboxIndex: null
    });
  };

  next = () => {
    this.setState({
      lightboxIndex: (this.state.lightboxIndex + 1) % this.props.images.length
    });
  };

  prev = () => {
    const i = this.state.lightboxIndex - 1;
    this.setState({
      lightboxIndex: i < 0 ? this.props.images.length - 1 : i
    });
  };

  render() {
    const masonryElements = this.props.images.map((img, i) => {
      return {
        key: img.url,
        span: i === 0 || i < this.props.images.length % 4 ? 2 : 1,
        element: (
          <Image
            pointer
            onClick={() => this.setLightboxIndex(i)}
            background
            ratio={1 / 1.5}
            file={img}
          />
        )
      };
    });
    return (
      <Container name="Gallery">
        {this.state.lightboxIndex !== null && (
          <Lightbox
            onNext={
              this.state.lightboxIndex === this.props.images.length - 1
                ? null
                : this.next
            }
            onPrev={this.state.lightboxIndex === 0 ? null : this.prev}
            onClose={this.closeLightbox}
            currentIndex={this.state.lightboxIndex}
            images={this.props.images}
          />
        )}
        {/* {masonryElements} */}
        <Masonry columns={4} gutter={"10px"} elements={masonryElements} />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/gallery.js